<script lang="ts">
  import { orgGarbage } from "@nrk/origo";
  import { getCurrentUser } from "services/api";
  import type { MimirSearchHit } from "services/searchHit";
  import { returnToSearchPage } from "state/page";
  import { onMount } from "svelte";
  import DeleteImageDialog from "./DeleteImageDialog.svelte";

  export let selectedItems: MimirSearchHit[] = [];
  export let deleteDialogIsOpen = false;
  export let extraCss: string = "";
  export let disabled = false;

  let dialogElement: HTMLElement;
  let hasBeenOpened = false; // Track if dialog has been opened at least once
  let wasDeleted = false;

  const currentUser = getCurrentUser();

  function onToggle(this: HTMLElement) {
    if (this !== dialogElement) {
      return;
    }

    const isNowHidden = this.hidden;

    if (!isNowHidden) {
      // Dialog is opening
      hasBeenOpened = true;
      deleteDialogIsOpen = true;
    } else if (hasBeenOpened) {
      // Dialog is closing AND has been opened before
      deleteDialogIsOpen = false;
      if (wasDeleted) {
        returnToSearchPage();
      }
      wasDeleted = false;
    }
  }

  onMount(() => {
    dialogElement.addEventListener("dialog-toggle", onToggle);

    return () => {
      dialogElement.removeEventListener("dialog-toggle", onToggle);
    };
  });
</script>

<button
  class="org-button org-button--hidden-large org-button--icon-left {extraCss}"
  data-for="delete-dialog"
  {disabled}
>
  {@html orgGarbage}
  Slett
</button>
<bb-dialog id="delete-dialog" hidden bind:this={dialogElement}>
  <!-- We hide the dialog with this boolean so we can use the Svelte lifecycle to start and stop machine -->
  {#if deleteDialogIsOpen}
    <DeleteImageDialog {selectedItems} on:deleted={() => (wasDeleted = true)} />
  {/if}
</bb-dialog>

<style>
  bb-dialog {
    width: 700px;
    max-width: 90vw;
  }
</style>
